// @flow
import * as React from 'react';
import { compose } from 'recompose';
import { Card, CardHeader, CardBlock } from 'reactstrap';
import type { ReportState } from 'types';

import SelectableState from 'components/SelectableState';

export type Filter = {
  selected: boolean,
  subtext: string,
};
type Props = {
  filters: ?{ [state: ReportState]: Filter },
  onFiltersChange: (state: ReportState, selected: boolean) => void,
};

class StateFilter extends React.Component<Props> {
  render() {
    const { filters, onFiltersChange } = this.props;
    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Filter</CardHeader>
        <CardBlock>
          {!!filters &&
            Object.keys(filters).map(state => {
              const { selected, subtext } = filters[state];
              return (
                <SelectableState
                  key={state}
                  state={state}
                  subtext={subtext}
                  selected={selected}
                  onClick={() => onFiltersChange(state, !selected)}
                />
              );
            })}
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

const StateFilterContainer = compose()(StateFilter);

export default StateFilterContainer;



// WEBPACK FOOTER //
// ./src/components/StateFilter/StateFilter.js